module.exports = __webpack_public_path__ + "static/media/ember.cf3e1c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/particles/ember.png
// module id = 2147
// module chunks = 3